import { graphql } from 'gatsby'
import React from 'react'

import Headline, {
  HeadlineContent,
} from 'src/components/organisms/general/headline'
import { PrismicPageDataBodyHeadline } from 'src/typings/generated/graphql'

type Props = {
  slice: PrismicPageDataBodyHeadline
}

const HeadlineSlice = ({ slice }: Props) => {
  const content: HeadlineContent = {
    anchor: slice.primary.anchor ?? undefined,
    headline: slice.primary.headline ?? undefined,
  }

  return <Headline content={content} />
}

export default HeadlineSlice

export const HeadlineFragment = graphql`
  fragment PageDataBodyHeadline on PrismicPageDataBodyHeadline {
    primary {
      anchor
      headline
    }
  }
`
